var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.status
  }, [_c('base-icon', {
    directives: [{
      name: "color",
      rawName: "v-color:black-2",
      arg: "black-2"
    }],
    attrs: {
      "name": "basic_eagle"
    }
  })], 1), _c('div', {
    class: _vm.$style.content
  }, [_c('base-loader')], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }